import { render, staticRenderFns } from "./Footer-Module.vue?vue&type=template&id=e19e888a&"
import script from "./Footer-Module.vue?vue&type=script&lang=js&"
export * from "./Footer-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports